module.exports = __webpack_public_path__ + "img/active_managers@2x.d8362e7f.png";